function storeLocalToUtc(date, time, timeZone) {
  const [year, month, day] = date.split('-').map((value) => parseInt(value, 10));
  const [hour, minute] = time.split(':').map((value) => parseInt(value, 10));

  if ([year, month, day, hour, minute].some((value) => Number.isNaN(value))) return null;

  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const target = {
    year: String(year).padStart(4, '0'),
    month: String(month).padStart(2, '0'),
    day: String(day).padStart(2, '0'),
    hour: String(hour).padStart(2, '0'),
    minute: String(minute).padStart(2, '0'),
  };

  let utc = Date.UTC(year, month - 1, day, hour, minute, 0);

  for (let attempt = 0; attempt < 12; attempt += 1) {
    const parts = Object.fromEntries(formatter.formatToParts(new Date(utc)).map((part) => [part.type, part.value]));
    const formatted = {
      year: parts.year,
      month: parts.month,
      day: parts.day,
      hour: parts.hour === '24' ? '00' : parts.hour,
      minute: parts.minute,
    };

    if (
      formatted.year === target.year &&
      formatted.month === target.month &&
      formatted.day === target.day &&
      formatted.hour === target.hour &&
      formatted.minute === target.minute
    ) {
      return utc;
    }

    const formattedMs = Date.UTC(
      parseInt(formatted.year, 10),
      parseInt(formatted.month, 10) - 1,
      parseInt(formatted.day, 10),
      parseInt(formatted.hour, 10),
      parseInt(formatted.minute, 10)
    );
    const targetMs = Date.UTC(year, month - 1, day, hour, minute, 0);
    utc += targetMs - formattedMs;
  }

  return utc;
}

function getScheduleTimestamps(element) {
  const timeZone = element.dataset.timezone;
  const endDate = element.dataset.endDate;
  if (!endDate || !timeZone) return null;

  const end = storeLocalToUtc(endDate, element.dataset.endTime || '23:59', timeZone);
  if (!end) return null;

  const start = element.dataset.startDate
    ? storeLocalToUtc(element.dataset.startDate, element.dataset.startTime || '00:00', timeZone)
    : null;

  return { start, end };
}

function isWithinSchedule(element) {
  const timestamps = getScheduleTimestamps(element);
  if (!timestamps) return true;

  const now = Date.now();
  if (timestamps.start && now < timestamps.start) return false;
  if (now >= timestamps.end) return false;
  return true;
}
